import { useState } from 'react';
//Components
import Button from '@mui/material/Button';
import Lineamientos from '../Lineamientos';

// Styles
import styles from './index.module.sass';

export default function Condiciones({
  idCuestionario,
  setSessionMessage,
  screenSize,
  setIsOpenModal,
}) {
  const [mostrarNuevoComponente, setMostrarNuevoComponente] = useState(false);

  function continuar() {
    setMostrarNuevoComponente(true);
  }

  return (
    <>
      {mostrarNuevoComponente ? (
        <Lineamientos
          idCuestionario={idCuestionario}
          setSessionMessage={setSessionMessage}
          setIsOpenModal={setIsOpenModal}
          screenSize={screenSize}
        />
      ) : (
        <div>
          <div className={`${styles.header} ${styles[screenSize]}`}>
            Le informamos que, una vez enviadas sus respuestas, no será posible realizar
            modificaciones.
          </div>

          <div className={styles.footer}>
            <Button className={styles.button} variant='contained' onClick={continuar}>
              Aceptar y Continuar
            </Button>
          </div>
        </div>
      )}
    </>
  );
}
